import React from "react";

const NotFound = () => (
  <div className="error">
    <div className="error-txt">
      <h1>404</h1>
      <p>Lo sentimos, esta URL no existe o ya no está disponible.</p>
      <a href="/">Ir al Dashboard de Docentes</a>
    </div>
  </div>
);

export default NotFound;